// extracted by mini-css-extract-plugin
export default {"cell":"calling-code-picker_cell__1mO4Q","icon":"calling-code-picker_icon__q-xGX","code":"calling-code-picker_code__wfCgF","selected":"calling-code-picker_selected__RQd6d"};